<span class="gray-text">
 <a href="#" [routerLink]="['/about' ]">
   <mat-icon class="info-icon" matTooltip="{{getFullVersionInfo()}}">info</mat-icon>
 </a>
</span>

